import { createExpandedSections } from "@shared/components/menus/expanded-sections"

// Beside LessonMenu rather than in it: a module exporting a component may export nothing else, or
// Vite's Fast Refresh gives up on the whole file (enforced by react-refresh/only-export-components).

/**
 * Which sections start expanded. Union of the editable + readonly options, plus the class-off
 * menu's "show-hide" — the whole point of that menu, so it opens to it.
 */
export const expandedSections = createExpandedSections([
  "copy-paste",
  "move",
  "copy-readonly",
  "print-readonly",
  "show-hide",
])
